// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyD06N8_-SV74smPyD3gEBXedogUsEczaBw',
    authDomain: 'travelgram-49fc4.firebaseapp.com',
    databaseURL: 'https://travelgram-49fc4.firebaseio.com',
    projectId: 'travelgram-49fc4',
    storageBucket: 'travelgram-49fc4.appspot.com',
    messagingSenderId: '532537854374',
    appId: '1:532537854374:web:24bf54a9f4615fe409e767',
    measurementId: 'G-YF7BHXM2SB',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
